module.exports = __webpack_public_path__ + "img/pBus.ca5993b4.png";